module.exports = __webpack_public_path__ + "img/logo.478e58ca.png";